import { PaymentMethodEnum } from '@/types/common';

export const getImageSize = (paymentMethod: PaymentMethodEnum) => {
  switch (paymentMethod) {
    default:
      return 'w-9 h-7';
  }
};
